import axios from 'axios';
import { Envelope } from '../interfaces/envelope';
import { Client } from '../interfaces/tenancy';

async function getClients(): Promise<Client[]> {
	try {
		const response = await axios.get<Envelope<Client[]>>(`clients`);
		return response.data.data;
	} catch (error) {
		if (axios.isAxiosError(error)) {
			throw error.response!.data;
		}
		throw error;
	}
}

export const clients = {
	getClients,
};
